/*
 * @providesModule RegistrationBannerStyles
 */

import {StyleSheet} from 'react-native';
import SkillzStyle from 'SkillzStyle';

const {fontExtraBold, textCenter} = SkillzStyle.fullStyles;

const styles = StyleSheet.create({
  bannerText: {
    ...fontExtraBold,
    ...textCenter,
    padding: 6,
    color: '#FFFFFF',
  },
});

export default styles;
